import { render } from "./Tal_gActiveBar.vue?vue&type=template&id=f22a614c"
import script from "./Tal_gActiveBar.vue?vue&type=script&lang=js"
export * from "./Tal_gActiveBar.vue?vue&type=script&lang=js"

import "./Tal_gActiveBar.vue?vue&type=style&index=0&id=f22a614c&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__